// Catálogo canónico de Fase Judicial, compartido entre AssetDetailPage.js
// (edición en pestaña "Datos del Activo") y JudicialDataCard.js (tarjeta
// "Datos judiciales" en Resumen). Debe reflejar el mismo catálogo que
// backend/services/fase_judicial_catalog.py.
export const FASE_JUDICIAL_LABELS = {
  sin_iniciar: 'Sin iniciar',
  demanda_presentada: 'Demanda presentada',
  auto_admision: 'Auto admisión',
  certificacion_registral: 'Recibida certificación registral',
  subasta_solicitada: 'Subasta solicitada',
  subasta_convocada: 'Subasta convocada',
  subasta_en_curso: 'Subasta en curso',
  subasta_celebrada: 'Subasta celebrada',
  auto_adjudicacion: 'Auto de adjudicación',
  adjudicacion: 'Adjudicación',
  lanzamiento: 'Lanzamiento',
  oposicion: 'Oposición',
  apelacion: 'Apelación',
  cerrado: 'Cerrado',
};
export const FASE_JUDICIAL_LIST = Object.keys(FASE_JUDICIAL_LABELS).map(v => ({ v, l: FASE_JUDICIAL_LABELS[v] }));
